import { IInvoice } from "../../invoice/application/dtos/IInvoiceData";
import { IOrderLogRepository } from "./interfaces/IOrderRepository";

const UpdateInvoiceOrderLogUseCase = async (repository: IOrderLogRepository, orderId: string, invoice: IInvoice[]) => {
    return await repository.updateInvoice(orderId, invoice);
};

export default UpdateInvoiceOrderLogUseCase;